import { render, staticRenderFns } from "./ImportProperty.vue?vue&type=template&id=1670e20f&scoped=true&"
import script from "./ImportProperty.vue?vue&type=script&lang=js&"
export * from "./ImportProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1670e20f",
  null
  
)

export default component.exports